<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <div class="d-md-flex align-items-center">
                            <div>
                                <h4 class="card-title">{{commodity.name}}</h4>
                                <h6 class="card-subtitle">Set rates and upload commodity images</h6>
                            </div>
                            <div class="ml-auto d-flex no-block align-items-center">
                                <div class="dl">
                                    <div class="button-group">
                                        <router-link
                                                :to="{name: 'edit-commodity', params: {commodityid: commodityid}}"
                                                class="btn btn-outline-secondary waves-effect waves-light">
                                            <i class="fas fa-pencil-alt"></i> Edit
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-lg-6">
                            <form class="form-horizontal r-separator">
                                <div class="card-body">
                                    <div class="form-group row">
                                        <label class="control-label text-right col-md-3">Name</label>
                                        <div class="col-md-9">
                                            <p class="form-control-static">{{commodity.name}}</p>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="control-label text-right col-md-3">Variety</label>
                                        <div class="col-md-9">
                                            <p class="form-control-static">{{commodity.variety}}</p>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="control-label text-right col-md-3">Native Name</label>
                                        <div class="col-md-9">
                                            <p class="form-control-static">{{commodity.native}}</p>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="control-label text-right col-md-3">Description</label>
                                        <div class="col-md-9">
                                            <p class="form-control-static">{{commodity.description}}</p>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="control-label text-right col-md-3">Category</label>
                                        <div class="col-md-9">
                                            <goods-services-category :category="commodity.category"/>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="control-label text-right col-md-3">Units</label>
                                        <div class="col-md-9">
                                            <p class="form-control-static">{{commodity.unit.symbol}}</p>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="control-label text-right col-md-3">Properties</label>
                                        <div class="col-md-9">
                                            <span v-bind:key="index" v-for="(cp, index) in commodity.commodity_props">
                                                <p class="form-control-static">{{cp.key | capitalize}}: {{cp.value}}</p>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="col-sm-12 col-lg-6 border-left">
                            <form @submit.prevent="handleAttachmentSubmit('attachment-form')" class="form-horizontal"
                                  data-vv-scope="attachment-form">
                                <div class="card-body">
                                    <div class="carousel slide" data-ride="carousel" id="carouselExampleIndicators"
                                         v-if="commodity.attachments && commodity.attachments.length>0">
                                        <div class="carousel-inner" role="listbox">
                                            <div class="carousel-item" v-bind:class="{active: index === 0}"
                                                 v-bind:key="index"
                                                 v-for="(attachment, index) in commodity.attachments">
                                                <img class="img-fluid" v-bind:src="attachment.src">
                                            </div>
                                        </div>
                                        <a class="carousel-control-prev" data-slide="prev"
                                           href="#carouselExampleIndicators" role="button">
                                            <span aria-hidden="true" class="carousel-control-prev-icon"></span>
                                            <span class="sr-only">Previous</span>
                                        </a>
                                        <a class="carousel-control-next" data-slide="next"
                                           href="#carouselExampleIndicators" role="button">
                                            <span aria-hidden="true" class="carousel-control-next-icon"></span>
                                            <span class="sr-only">Next</span>
                                        </a>
                                    </div>

                                    <div class="form-group row m-t-40">
                                        <label class="col-sm-3 text-right control-label col-form-label"
                                               for="attachment">Attachment</label>
                                        <div class="col-sm-7">
                                            <div class="input-group">
                                                <div class="custom-file">
                                                    <input :class="{'is-invalid': submitted && errors.has('attachment-form.attachment')}"
                                                           accept=".JPG,.JPEG,.PNG"
                                                           class="custom-file-input"
                                                           data-vv-as="attachment"
                                                           id="attachment"
                                                           name="attachment"
                                                           ref="file"
                                                           type="file"
                                                           v-on:change="onFileChange()"
                                                           v-validate="'required'">
                                                    <label class="custom-file-label">{{filename}}</label>
                                                </div>
                                            </div>
                                            <small class="form-text text-muted">{{uploadstatus}}</small>
                                            <div class="invalid-feedback"
                                                 v-if="submitted && errors.has('attachment-form.attachment')">{{
                                                errors.first('attachment-form.attachment') }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer">
                                    <div class="form-group m-b-0 text-right">
                                        <div class="button-group">
                                            <button class="btn waves-effect waves-light btn-success" type="submit">
                                                Save
                                            </button>
                                            <button @click="resetAttachment()"
                                                    class="btn waves-effect waves-light btn-secondary" type="button">
                                                Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12 col-lg-6">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Rates</h4>
                        <h6 class="card-subtitle">Set the support and resistance rates</h6>
                    </div>

                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table no-wrap v-middle">
                                <thead>
                                <tr class="border-0">
                                    <th class="border-0">From</th>
                                    <th class="border-0">To</th>
                                    <th class="border-0">Rate</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-bind:key="index" v-for="(rate, index) in rates">
                                    <td>{{rate.lower | medium}}</td>
                                    <td>{{rate.upper | medium}}</td>
                                    <td>{{rate.rate | money}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="p-15">
                        <nav aria-label="Page navigation example">
                            <paginate
                                    :click-handler="pageHandler"
                                    :container-class="'pagination float-right'"
                                    :margin-pages="2"
                                    :next-class="'page-link'"
                                    :next-text="'Next'"
                                    :page-class="'page-link'"
                                    :page-count=pageCount
                                    :page-range="3"
                                    :prev-class="'page-link'"
                                    :prev-text="'Prev'">
                            </paginate>
                        </nav>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-lg-6">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Add New Rate</h4>
                        <h6 class="card-subtitle">Rates can be dynamic</h6>
                    </div>
                    <form @submit.prevent="handleRateSubmit('rate-form')" class="form-horizontal"
                          data-vv-scope="rate-form">
                        <div class="card-body card-blue">
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="rate">Rate</label>
                                <div class="col-sm-6">
                                    <input :class="{'is-invalid': submitted && errors.has('rate-form.rate')}"
                                           class="form-control"
                                           data-vv-as="rate"
                                           id="rate"
                                           name="rate"
                                           placeholder="Rate"
                                           step="any"
                                           type="number"
                                           v-model="rate.rate"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('rate-form.rate')">{{
                                        errors.first('rate-form.rate') }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label">Currency</label>
                                <div class="col-sm-6">
                                    <input :value="currentOrg.currency_symbol" class="form-control" readonly type="text"
                                           v-if="currentOrg.currency_symbol">
                                    <input class="form-control" readonly type="text" v-if="!currentOrg.currency_symbol"
                                           value="N/A">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('rate-form.currency')">
                                        {{ errors.first('rate-form.currency') }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="from">Valid
                                    From</label>
                                <div class='col-sm-6'>
                                    <input
                                            :class="{'is-invalid': submitted && errors.has('rate-form.from')}"
                                            :min="min"
                                            autocomplete="off"
                                            class="form-control"
                                            data-vv-as="from"
                                            id="from"
                                            name="from"
                                            placeholder="mm/dd/yyyy"
                                            type="text"
                                            v-model="rate.from"
                                            v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('rate-form.from')">{{
                                        errors.first('rate-form.from') }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="to">Valid
                                    To</label>
                                <div class='col-sm-6'>
                                    <input :class="{'is-invalid': submitted && errors.has('rate-form.to')}"
                                           :min="rate.from"
                                           autocomplete="off"
                                           class="form-control"
                                           data-vv-as="to"
                                           id="to"
                                           name="to"
                                           placeholder="mm/dd/yyyy"
                                           type="text"
                                           v-model="rate.to"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('rate-form.to')">{{
                                        errors.first('rate-form.to') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="form-group m-b-0 text-right">
                                <div class="button-group">
                                    <button class="btn waves-effect waves-light btn-success" type="submit">Save</button>
                                    <button @click="resetRate()" class="btn waves-effect waves-light btn-secondary"
                                            type="button">Reset
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Add Property</h4>
                        <h6 class="card-subtitle">Add commodity properties which ensure quality of this commodity</h6>
                    </div>
                    <form @submit.prevent="handleCommPropSubmit('prop-form')" class="form-horizontal"
                          data-vv-scope="prop-form">
                        <div class="card-body card-blue">
                            <div class="form-group row" v-bind:key="index" v-for="(row, index) in commodity_props">
                                <label :for="'commodity_id'+index"
                                       class="col-sm-3 text-right control-label col-form-label" v-if="index === 0">Commodity
                                    Property</label>
                                <label class="col-sm-3" v-if="index > 0"></label>
                                <div class="col-sm-3">
                                    <input :class="{'is-invalid': com_prop_submitted && errors.has('propname'+index)}"
                                           :name="'propname'+index"
                                           class="form-control"
                                           data-vv-as="propname"
                                           placeholder="Property Name"
                                           style="height: 42px;"
                                           type="text"
                                           v-model="row.key"
                                           v-validate="'required'">
                                    <div class="invalid-feedback"
                                         v-if="com_prop_submitted && errors.has('propname'+index)">{{
                                        errors.first('propname'+index) }}
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <input :class="{'is-invalid': com_prop_submitted && errors.has('propval'+index)}"
                                           :name="'propval'+index"
                                           class="form-control"
                                           data-vv-as="propval"
                                           placeholder="Property Description"
                                           style="height: 42px;"
                                           type="text"
                                           v-model="row.value"
                                           v-validate="'required'">
                                    <div class="invalid-feedback"
                                         v-if="com_prop_submitted && errors.has('propval'+index)">{{
                                        errors.first('propval'+index) }}
                                    </div>
                                </div>
                                <div class="col-sm-2">
                                    <div class="form-group button-group">
                                        <button @click="addRow()" class="btn btn-success" style="height: 40px;"
                                                type="button" v-if="index === commodity_props.length - 1"><i
                                                class="fa fa-plus"></i>
                                        </button>
                                        <button @click="removeRow(index)" class="btn btn-danger" style="height: 40px;"
                                                type="button" v-else><i class="fa fa-minus"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="form-group m-b-0 text-right">
                                <div class="button-group">
                                    <button class="btn waves-effect waves-light btn-success" type="submit">Save</button>
                                    <button @click="resetCommProp()" class="btn waves-effect waves-light btn-secondary"
                                            type="button">Reset
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Paginate from 'vuejs-paginate';
    import axios from 'axios';
    import Multiselect from 'vue-multiselect';
    import CurrencySelect from '../../common/CurrencySelect';
    import GoodsServicesCategory from "../../express/purchases/goods-services/GoodsServicesCategory";

    export default {
        name: "ViewCommodity",
        props: ["commodityid"],
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {GoodsServicesCategory, Paginate, Multiselect, CurrencySelect},
        data() {
            return {
                submitted: false,
                com_prop_submitted: false,
                commodity_props: [{
                    key: null,
                    value: null
                }],
                commodity: {
                    name: '',
                    variety: '',
                    native: '',
                    category: '',
                    description: '',
                    commodity_props: [
                        {
                            key: null,
                            value: null
                        }
                    ],
                    unit: {
                        id: "null",
                        name: '',
                        symbol: ''
                    }
                },
                rate: {
                    rate: null,
                    currencyid: null,
                    from: null,
                    to: null,
                },
                rates: [],
                pageCount: 1,
                total: 0,
                min: '2019-01-01',
                file: File,
                filename: "No File Chosen",
                uploadstatus: '',
                attachments: []
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            async init() {
                if (!this.currentOrg.currency_id) {
                    this.$toastr('warning', 'Base Currency is not set, set it first', 'Warning');
                }
                jQuery('#from').datepicker({
                    autoclose: true,
                    todayHighlight: true
                }).on('change', (event) => {
                    this.rate.from = event.target.value;
                });

                jQuery('#to').datepicker({
                    autoclose: true,
                    todayHighlight: true
                }).on('change', (event) => {
                    this.rate.to = event.target.value;
                });
                this.submitted = false;
                this.com_prop_submitted = false;
                this.resetRate();
                this.resetAttachment();
                await this.getCommodity();
                await this.getDownloadUrl();
                await this.getRates(1);
                if (this.rates.length > 0) {
                    this.min = this.rates[0].lower;
                }
            },
            addRow() {
                this.commodity_props.push({
                    key: null,
                    value: null
                });
            },
            removeRow(index) {
                this.commodity_props.splice(index, 1);
            },
            async getCommodity() {
                $(".preloader").fadeIn();
                let row = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/commodities/${this.commodityid}`);
                $(".preloader").fadeOut();
                this.commodity = row.data;
            },
            async getRates(page) {
                let reply = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/commodities/${this.commodityid}/rates`, {
                    params: {
                        page: page,
                        perPage: 10
                    }
                });
                this.total = reply.data.total;
                this.rates = reply.data.rates;
                this.setPageCount();
            },
            setPageCount() {
                this.pageCount = this.total <= 10 ? 1 : Math.ceil(this.total / 10);
            },
            pageHandler(pageNum) {
                this.getRates(pageNum);
            },
            async saveRate() {
                if (!this.currentOrg.currency_id) {
                    this.$toastr('error', 'Base Currency is not set, set it first', 'Error');
                    this.$router.push({name: "editsettings"});
                    return;
                }
                try {
                    await this.$http.put(`/marketplaces/${this.currentOrg.marketplace_id}/commodities/${this.commodityid}/rates`, this.rate);
                    await this.init();
                    if (this.rates.length > 0) {
                        this.min = this.rates[0].lower;
                    }
                    this.$toastr('success', 'New rate added', 'Success');
                } catch (err) {
                    this.$toastr('error', 'Rate update failed. Please ensure date ranges do not overlap.', 'Failed');
                }
            },
            handleRateSubmit(scope) {
                this.submitted = true;
                this.$validator.validateAll(scope)
                    .then(valid => {
                        if (valid) {
                            this.saveRate();
                        }
                    });
            },
            handleCommPropSubmit(scope) {
                this.com_prop_submitted = true;
                this.$validator.validateAll(scope)
                    .then(valid => {
                        if (valid) {
                            this.saveCommProp();
                        }
                    });
            },
            async saveCommProp() {
                try {
                    await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/commodities/${this.commodityid}/props`, this.commodity_props);
                    this.getCommodity();
                    this.commodity_props = [{
                        key: null,
                        value: null
                    }],
                        this.$toastr('success', 'Commodity Property added', 'Success');
                } catch (err) {
                    this.$toastr('error', 'Commodity Property update failed.', 'Failed');
                }
            },
            resetCommProp() {
                this.commodity_props = [{
                    key: null,
                    value: null
                }]
            },
            resetRate() {
                this.rate = {
                    rate: null,
                    currencyid: null,
                    from: null,
                    to: null
                }
            },
            async onFileChange() {
                this.uploadstatus = 'Uploading file, please wait ...';
                this.file = this.$refs.file.files[0];
                this.filename = this.file.name;
                let signedurl = await this.getUploadUrl(this.commodity.id, this.filename);
                let uploaded = await this.uploadFile(signedurl.data.url);
                this.attachments = this.commodity.attachments ? this.commodity.attachments : [];
                this.attachments.push({
                    filename: this.filename,
                    filepath: signedurl.data.key,
                    contenttype: this.file.type.split('/')[1]
                });
                this.uploadstatus = 'File uploaded'
            },
            async getUploadUrl(warehouseId, filename) {
                let signedUrl = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/commodities/${this.commodityid}/signedurl`, {
                    params: {
                        name: filename,
                        type: 'write'
                    }
                });
                return signedUrl;
            },
            async getDownloadUrl() {
                if (this.commodity.attachments && this.commodity.attachments.length > 0) {
                    for (const attachment of this.commodity.attachments) {
                        let filepath = attachment.filepath;
                        let result = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/commodities/${this.commodityid}/signedurl`, {
                            params: {
                                key: filepath,
                                type: 'read'
                            }
                        });
                        attachment['src'] = result.data.url;
                    }
                }
                this.commodity = JSON.parse(JSON.stringify(this.commodity));
            },
            async saveAttachment() {
                try {
                    await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/commodities/${this.commodityid}`, {attachments: this.attachments});
                    await this.init();
                    this.$toastr('success', 'Commodity updated', 'Success');
                } catch (err) {
                    this.$toastr('error', 'Rate update failed', 'Failed');
                }
            },
            handleAttachmentSubmit(scope) {
                this.submitted = true;
                this.$validator.validateAll(scope)
                    .then(valid => {
                        if (valid) {
                            this.saveAttachment();
                        }
                    });
            },
            async uploadFile(signedUrl) {
                await axios.put(signedUrl, this.file);
            },
            resetAttachment() {
                this.attachments = [];
                this.$refs.file.value = '';
                this.uploadstatus = '';
                this.filename = "No File Chosen";
            },
            setCurrency(e) {
                console.log(e);
                if (e) {
                    this.rate.currencyid = e.id;
                } else {
                    this.rate.currencyid = null;
                }
            }
        }
    }
</script>

<style scoped>
    .invalid-feedback {
        display: block;
    }

    #carouselExampleIndicators {
        padding: 0.25rem;
        background-color: #eef5f9;
        border: 1px solid #dee2e6;
        border-radius: 2px;
        max-width: 100%;
        height: auto;;
    }

    .carousel-item {
        text-align: center;
    }

    .carousel-item > img {
        height: 100px;
        border-radius: 5px;
    }
</style>
